<template>
  <div class="account">
    <div class="main-content">
      <div class="account-list-container">
        <div class="section-header text-center mobile-hide">
          <h2>{{ $t('productList') }}</h2>
        </div>
        <div class="filters-toolbar-wrapper">
          <div class="filters-toolbar__item-child">
            <p>Per Page</p>
            <el-select v-model="limit" v-bind:placeholder="$t('limit')" value="" @change="updateLimit">
              <el-option
                v-for="item in limitOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <table class="responsive-table">
          <thead>
            <tr>
              <th></th>
              <th>{{ $t('sku') }}</th>
              <th>{{ $t('productName') }}</th>
              <th>{{ $t('weight') }}</th>
              <th>{{ $t('price') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in this.$store.state.orders.productList" data-index="index" :key="index" class="responsive-table__row">
              <td data-label="Detail">
                <p class="btn" @click="goToProductDetail(item.Product_id)">
                  View Product Detail
                </p>
              </td>
              <td data-label="RefNum">#{{item.RefNum}}</td>
              <td data-label="Name">{{item.Name}}</td>
              <td data-label="weight"></td>
              <td data-label="RefPrice">${{item.RefPrice}}</td>
            </tr>
          </tbody>
        </table>
        <pagination
          :totalPages="pages"
          :total="count"
          :currentPage="currentPage"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    
    <!-- product detail -->
    <el-dialog
      v-bind:title="$t('productDetail')"
      :visible.sync="detailModalVisible"
      @close="handleClose"
      class="modal"
    >
      <table class="responsive-table">
        <tr>
          <th>{{ $t('inboundOrder') }}</th>
          <td data-label="ordered_inbound">{{productDetail.ordered_inbound}}</td>
        </tr>
        <tr>
          <th>{{ $t('receivedInboundOrder') }}</th>
          <td data-label="received_inbound">{{productDetail.received_inbound}}</td>
        </tr>
        <tr>
          <th>{{ $t('outboundOrder') }}</th>
          <td data-label="ordered_outbound">{{productDetail.ordered_outbound}}</td>
        </tr>
        <tr>
          <th>{{ $t('mso') }}</th>
          <td data-label="ordered_outbound_mobile">{{productDetail.ordered_outbound_mobile}}</td>
        </tr>
        <tr>
          <th>{{ $t('outboundInvoice') }}</th>
          <td data-label="invoiced_outbound">{{productDetail.invoiced_outbound}}</td>
        </tr>
        <tr>
          <th>{{ $t('msoInvoice') }}</th>
          <td data-label="invoiced_outbound_mobile">{{productDetail.invoiced_outbound_mobile}}</td>
        </tr>
      </table>
    </el-dialog>
    <!-- end product detail -->
    
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import pagination from "../../components/pagination";

export default {
  name: "productList",
  components: {
    pagination,
  },
  data() {
    return {
      path2: this.$t('productList'),
      currentPage: 1,
      // filter for limit
      limit: '15',
      limitOptions: [
        { value: '15', label: '15' },
        { value: '30', label: '30' },
        { value: '50', label: '50' },
        { value: '100', label: '100'},
      ],
      detailModalVisible: false,
      productDetail: {
        ordered_inbound: 0,
        received_inbound: 0,
        ordered_outbound: 0,
        ordered_outbound_mobile: 0,
        invoiced_outbound: 0,
        invoiced_outbound_mobile: 0,
      },
    }
  },
  methods: {
    ...mapActions('orders', ['fetchProductList', 'fetchProductDetails', 'fetchProductDetails']),
    updateLimit(value) {
      this.limit = value;
      this.updateFilter();
    },
    updateFilter() {
      const page = this.currentPage || 1;
      let limit = ''
      if (this.limit) {
        limit = this.limit;
      }
      this.$store.dispatch('orders/fetchProductList', [limit, page]);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.updateFilter();
      window.scrollTo(0, 0);
    },
    goToProductDetail(id) {
      this.fetchProductDetails(id)
      .then(res => {
        this.productDetail = res.data;
        this.detailModalVisible = true;
      })
      .catch(err => {
        console.log('productDetail error: ', err);
      });
    },
    handleClose(event) {
      event.preventDefault();
      this.detailModalVisible = false;
    },
  },
  computed: mapState({
    pages: state => state.orders.productListPaginate,
    count: state => state.orders.productListCount,
  }),
  mounted() {
    this.$store.dispatch('orders/fetchProductList', [this.limit, 1]);
  },
}
</script>

<style scoped lang="less">
@import "../../assets/css/accountList.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/productList.vue